import { getCsRegexPatternForPath } from '../../../utils/contentStackUtils'

export const getCsEntries = async props => {
  const {
    contentStackContainer,
  } = require('../../../models/ContentStack/ContentStack')

  const {
    url,
    context,
    contextName = 'csPageEntry',
    isToSkipContextLoad = false,
  } = props
  const regexPattern = getCsRegexPatternForPath(url)
  const queryString = encodeURIComponent(
    JSON.stringify({
      $or: [{ url: '/default' }, { url: { $regex: regexPattern } }],
    })
  )

  
  const response =  await contentStackContainer.getCSPageEntry({
    context,
    contextName,
    queryParams: `&query=${queryString}&include_fallback=true`,
    url,
    isToSkipContextLoad,
  })

  return response
}
